/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EmailOpenIcon = ({
  className,
  style: styleFromProps,
  color = '#BFBFBF',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <path
        d="M14.6373 13.1C14.948 13.1 15.1998 12.8482 15.1998 12.5375V6.21982C15.1998 5.44902 14.8123 4.74073 14.1631 4.32501L12.8092 3.45808V1.36255C12.8092 1.05186 12.5574 0.800049 12.2467 0.800049H3.75293C3.44224 0.800049 3.19043 1.05186 3.19043 1.36255V3.45566L1.83735 4.32117C1.18762 4.73678 0.799805 5.4454 0.799805 6.21664V12.95C0.799805 14.1907 1.80912 15.2 3.0498 15.2H12.9498C14.1905 15.2 15.1998 14.1907 15.1998 12.95C15.1998 12.6394 14.948 12.3875 14.6373 12.3875C14.3266 12.3875 14.0748 12.6394 14.0748 12.95C14.0748 13.5703 13.5701 14.075 12.9498 14.075H3.0498C2.42952 14.075 1.9248 13.5703 1.9248 12.95V6.94921L6.81163 9.98792C7.17814 10.2158 7.58892 10.3297 7.9998 10.3297C8.41058 10.3297 8.82158 10.2158 9.18798 9.98792L14.0748 6.94921V12.5375C14.0748 12.8482 14.3266 13.1 14.6373 13.1ZM13.5565 5.27247C13.7263 5.38124 13.8598 5.53021 13.949 5.70259L12.8092 6.41143V4.79391L13.5565 5.27247ZM2.44358 5.26896L3.19043 4.79116V6.41143L2.04928 5.70182C2.1386 5.52823 2.27274 5.37816 2.44358 5.26896ZM8.59384 9.03254C8.22744 9.2604 7.77217 9.2604 7.40577 9.03254L4.31543 7.11093V1.92505H11.6842V7.11093L8.59384 9.03254Z"
        fill={color}
      />
    </svg>
  );
};
